import React from 'react';
import styled from 'styled-components';

import AdList from './AdList';
import Header from './Header';

const Container = styled.div`
  background-color: white;
  display: grid;
  grid-template-rows: 60px 1fr;
  height: 100vh;
`;

function ListView() {
  return (
    <Container>
      <Header />
      <AdList />
    </Container>
  );
}

export default ListView;
